import { DateRangePicker, Autocomplete, AutocompleteItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { useFetchData } from "@/hooks";
import { parseDate } from "@internationalized/date";

/**
 * Filter component for Egg Conversion page (warehouse + date range).
 */
const FilterData = ({ table, initialFilters }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const { data: warehouses } = useFetchData("select/warehouse");

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    const dateRangeValue =
        pending.date_from && pending.date_to
            ? {
                  start: parseDate(pending.date_from),
                  end: parseDate(pending.date_to),
              }
            : null;

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRangeValue}
                onChange={(range) =>
                    setPending((prev) => ({
                        ...prev,
                        date_from: range?.start?.toString() || "",
                        date_to: range?.end?.toString() || "",
                    }))
                }
                variant="flat"
            />

            <Autocomplete
                label="Gudang"
                placeholder="Semua Gudang"
                variant="flat"
                selectedKey={pending.warehouse_id || null}
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        warehouse_id: key || "",
                    }))
                }
                isClearable
                onClear={() =>
                    setPending((prev) => ({ ...prev, warehouse_id: "" }))
                }
            >
                {(warehouses || []).map((w) => (
                    <AutocompleteItem key={String(w.value)}>
                        {w.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>
        </FilterCard>
    );
};

export default FilterData;
